// extracted by mini-css-extract-plugin
export default {"InfoRow":"shared_InfoRow__I5jdI","InfoLabel":"shared_InfoLabel__1ZuoL","InfoInput":"shared_InfoInput__dCKN2"};